import type { BrandConfig, ConverterTheme } from "./types";

interface FooterProps {
  brand: BrandConfig;
  description: string;
  theme: ConverterTheme;
}

const Footer = ({ brand, description, theme }: FooterProps) => (
  <footer className="mt-auto w-full border-t border-slate-200 py-10 text-center text-sm text-slate-400 dark:border-slate-800 dark:text-slate-500">
    <p className="mb-1 font-medium">
      <strong className="text-slate-600 dark:text-slate-300" translate="no">
        {brand.name}
      </strong>{" "}
      {description}
    </p>
    <p className="text-xs">
      © {new Date().getFullYear()}{" "}
      <a
        href="https://trevisoft.dev"
        target="_blank"
        rel="noopener noreferrer"
        className={`rounded font-bold text-slate-600 underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 ${theme.focusRing} dark:text-slate-300 ${theme.linkHover}`}
        translate="no"
      >
        TREVISOFT
      </a>
      . All rights reserved.
    </p>
  </footer>
);

export default Footer;
